import React from 'react';
import { isMadPawsStore } from '../../../common/util';

const FacetEmptyIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.773438"
        y="0.5"
        width="19"
        height="19"
        rx="1.5"
        stroke={isMadPawsStore() ? '#ABABAB' : '#C9D5DA'}
      />
    </svg>
  );
};

export default FacetEmptyIcon;
